@if (isPlatformBrowser(platformId)) {
    <ds-geospatial-map [mapInfo]="mapInfo"></ds-geospatial-map>
}
